import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware, { END } from "redux-saga";
import rootSaga from "./../sagas";
import survey from "./survey";
import popup from "./popup";
import user from "./user";
import order from "./order";

var devTools;

if ((process.env.NODE_ENV === "prod" || process.env.NODE_ENV ===
		"production") || !window.__REDUX_DEVTOOLS_EXTENSION__) {
	devTools = a => a;
} else {
	devTools = window.__REDUX_DEVTOOLS_EXTENSION__ &&
		window.__REDUX_DEVTOOLS_EXTENSION__();
}

const rootReducer = combineReducers({
	user,
	popup,
	survey,
	order,
	routing: routerReducer
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
	rootReducer,
	compose(
		applyMiddleware(sagaMiddleware),
		devTools,
	),
);

store.close = () => store.dispatch(END);
sagaMiddleware.run(rootSaga);

export default store;


// WEBPACK FOOTER //
// ./src/reducers/index.js